import { render } from "./forgot-password.html?vue&type=template&id=2a29352f&ts=true"
import script from "./forgot-password.ts?vue&type=script&lang=ts"
export * from "./forgot-password.ts?vue&type=script&lang=ts"

import "./forgot-password.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__